import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
@Component({
  selector: 'app-property-tax-form-configuration',
  templateUrl: './property-tax-form-configuration.component.html',
  styleUrls: ['./property-tax-form-configuration.component.css']
})
export class PropertyTaxFormConfigurationComponent {
  constructor(private router: Router, private location: Location) { }
  onCardClick(card) {
    this.router.navigate([`/${card}`]);
  }
  goBack(): void {
    this.location.back();
  }
}
